const whitespace = new RegExp(/^\s*$/);

/** Returns true if the specified value is null, undefined, or whitespace. */
export function isNullOrWhitespace(value: string | null | undefined): boolean {
  return value == null || value.match(whitespace) !== null;
}
